import { event } from '../../../Foundation';
import { ProductDropdownEventListeners } from '../functions/sharedEvents';
import { ProductDropdownTemplate } from '../template/template';
import {
  getData,
  getDataAttribute,
  getDataValues,
  getAccessories,
} from '../functions/sharedFunctions';

export class ProductDropdownReceivers {
  constructor(elem, _refs) {
    this.elem = elem;
    this._refs = { ..._refs };

    const listOfAttributes = [
      'data-filter-sideproperty',
      'data-filter-side',
      'data-filter-tubeside',
    ];
    const sideAttribute = getDataAttribute(this._refs.contentAccessory, listOfAttributes);
    // Get available side
    const contentSides = getDataValues(this._refs.contentAccessory, sideAttribute);
    // Get accessories
    const accessoriesElements = getAccessories(this._refs.contentAccessory, sideAttribute);
    // Create get data settings
    const dataSettings = {
      elem: this._refs.contentAccessory,
      dataAttribute: sideAttribute,
      availableDataValues: contentSides,
      accessoriesElements,
    };

    getData(dataSettings, this.getDataResponse.bind(this));
  }

  /**
   * Create template
   * @returns {String}
   */
  createTemplate() {
    this.elem.innerHTML = this.template.createTemplate();
  }

  /**
   * Get data, build template and initiate event listeners
   * @param {Object} data
   */
  getDataResponse(data) {
    this._refs = { ...this._refs, ...data };
    this.template = new ProductDropdownTemplate(this._refs);
    this.eventListeners = new ProductDropdownEventListeners(this.elem, this._refs);
    this.init();
  }

  /**
   * Actions
   */
  showContentSide() {
    const sideSelector = Array.from(
      document.querySelectorAll('.is-side-selection input[type=radio]'),
    );
    let selectedSide = sideSelector.filter((el) => el.checked).map((el) => el.value);
    if (selectedSide.length < 1) return;
    this.toggleDropdownField(selectedSide);
    this.toggleAddMoreButton(selectedSide);
    this.toggleSideVisibility(selectedSide);
  }

  /**
   * Enabled/Disabled field when content side is visible/hidden
   * @param {Array} selectedSide
   * @returns
   */
  toggleDropdownField(selectedSide) {
    let side = '';
    const contentSelectors = Array.from(
      this.elem.querySelectorAll(`.configurator__dropdown .configurator__accessories-item select`),
    );
    selectedSide = selectedSide[0].toLowerCase();
    if (selectedSide !== 'binaural') {
      /* eslint-disable-next-line */
      side = `.item_${selectedSide}`;
    }
    for (let elem of contentSelectors) {
      const elemSide = elem.getAttribute('data-item');
      elem.classList.add('is-disabled');
      if (elemSide === selectedSide || selectedSide === 'binaural') {
        elem.classList.remove('is-disabled');
      }
      event.emit(elem, 'reflow');
    }
  }

  /**
   * Activate and deactivate Add More Buttons
   * @param {Array} selectedSide
   * @returns
   */
  toggleAddMoreButton(selectedSide) {
    const selectSide = selectedSide[0].toLowerCase();
    const buttons = Array.from(this.elem.querySelectorAll(`.addAccessoryDropdown`));
    const sideValues = buttons.map((el) => el.getAttribute('data-item'));
    if (!sideValues.includes(selectSide)) return;
    for (let side of sideValues) {
      this.eventListeners.deactivateAddMoreButton(side);
      if (side === selectSide) {
        this.eventListeners.activateAddMoreButton(side);
      }
    }
  }

  /**
   * Toggle show/hide when user select side
   * @param {Array} selectedSide
   * @returns
   */
  toggleSideVisibility(selectedSide) {
    const selectSide = selectedSide[0].toLowerCase();
    const dropdownContents = Array.from(
      this.elem.querySelectorAll(`.configurator__accessories-content_item, .configurator__addMore`),
    );
    const sideValues = dropdownContents.map((el) => el.getAttribute('data-item'));
    if (!sideValues.includes(selectSide)) return;
    for (let elem of dropdownContents) {
      elem.classList.add('is-hidden');
      if (elem.dataset.item === selectSide) {
        elem.classList.remove('is-hidden');
      }
    }
  }

  init() {
    if (!this._refs.data) return;
    // create template
    this.createTemplate();
    this.eventListeners.watchEvents();
    this.showContentSide();
    if (this._refs.bundle) return;
    this.eventListeners.validateAddMoreFields();
  }
}
